import type { ProfilePerClient } from '~/providers/types/api-private';

type ClientPermissionsInput = {
  userType: string;
  clientProfile: ProfilePerClient;
  flags: { automation: boolean; registryEdit: boolean };
  editorIsAdminConta: boolean;
  hasSpecificUnits: boolean;
  // Quem não pode conceder a edição de cadastros mantém o estado que já estava gravado no usuário.
  registryEditGrant: { editorCanChange: boolean; saved: boolean };
};

type RegistryEditEditor = { manageAllClients?: boolean; isAdminConta?: boolean };

// Só Diel e Admin de Conta concedem ou retiram a edição de cadastros; isso evita a autoconcessão pelo Admin do cliente.
export function canChangeRegistryEdit(editor: RegistryEditEditor): boolean {
  return !!(editor.manageAllClients || editor.isAdminConta);
}

type SelectableUnit = { checked?: boolean };

// Um subconjunto de unidades marcadas (nem nenhuma, nem todas) torna o usuário Admin por unidade.
export function hasSpecificUnitsSelected(units: SelectableUnit[] | null | undefined): boolean {
  if (!units || units.length === 0) return false;
  const checkedCount = units.filter((unit) => unit.checked).length;
  return checkedCount > 0 && checkedCount < units.length;
}

function grantsAutomation(input: ClientPermissionsInput): boolean {
  if (input.clientProfile !== '[U]' && input.flags.automation) return true;
  // O Admin de Conta sempre concede automação aos Admins que ele cadastra.
  return input.clientProfile === '[C]' && input.editorIsAdminConta;
}

export function buildClientPermissions(input: ClientPermissionsInput): ProfilePerClient[] {
  if (input.userType === 'instalador') return ['[I]'];
  if (input.userType === 'administradorDeConta' && input.clientProfile === '[ADMC]') return ['[ADMC]'];
  if (input.userType !== 'cliente') return [input.clientProfile];

  const permissions: ProfilePerClient[] = grantsAutomation(input) ? ['[C]', '[CP]'] : [input.clientProfile];
  // A edição de cadastros só vale para o Admin no nível do cliente; o backend rejeita a sigla com unidades específicas.
  const wantsRegistryEdit = input.registryEditGrant.editorCanChange ? input.flags.registryEdit : input.registryEditGrant.saved;
  if (input.clientProfile === '[C]' && wantsRegistryEdit && !input.hasSpecificUnits) {
    permissions.push('[CE]');
  }
  return permissions;
}
